import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import { YES_OR_NO } from "../../../../../../utils/constant.utils";
import Icons from '../../../../../icon';
import { ORDER_STATUS, CIRCUIT_STATUS } from "../../../../../../constants/external-constants";

export class ChangeVendorDetails extends Component {
    constructor(props) {
        super(props);
    }

    renderPlanComponents = props => {
        const { PlanComponents } = this.props.data.NewRequest.PlanDetails;
        return PlanComponents != null && PlanComponents.length != 0
            ? PlanComponents.map((item, i) => (
                <tr key={i}>
                    <td>{i === 0 ? <Translation translationKey="plan_component" /> : null}</td>
                    <td>{item.ComponentDetails}</td>
                </tr>
            ))
            : null;
    };

    displayAccessories = (accessories, currency) => {

        return accessories != null && accessories.length != 0
            ? accessories.map((item, i) => (

                <tr key={i}>
                    <td>{i == 0 ? <Translation translationKey="accessory" /> : null}</td>
                    <td>
                        <Row>
                            <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                                {item.EquipmentModel}
                            </Col>
                            <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                                {currency} {item.OrderCost.toFixed(2)}
                            </Col>
                        </Row>
                    </td>
                </tr>
            ))
            : null;
    }

    editRequest = (orderStatusId, endUserId, requestorId) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);
        const showUpdateRequestLink = this.props.history.location.pathname.match(/Inventory.*/) === null ? true : false;

        return editableRequest && isRequestOwner && showUpdateRequestLink;
    }

    render() {
        const {  status, data, isWireline, openRequestModal, selectedItem } = this.props;
        const { Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId } } = data || {};
        return (
            <div>               
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId) ?  
                        <Icons
                        customClassName="pen-to-square"
                        name="pen-to-square"
                        size="20px"
                        containerClass="icon-circle-plus-container"
                        onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                        labelValue={"Update Order Request"}
                        labelClass="order-detail-edit-label"                                                              
                    />

                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    {data.Order.IsRequestedInBehalf ? 
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.OldVendorDetailName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName ?
                                    data.Subscription.PlanDetails.PlanName :
                                    <Translation translationKey="no_plan_available" />}</td>
                            </tr>
                          
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="change_new_vendor_capital" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                <td>{data.BillingAddress && data.BillingAddress.CountryName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="delivery_address" /></td>
                                <td>{data.BillingAddress && (data.OtherLocationName ? data.OtherLocationName : data.BillingAddress.DeliveryAddress)}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="new_vendor" /></td>
                                <td>{data.NewRequest.Vendor && data.NewRequest.Vendor.VendorName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="circuit_type" /></td>
                                <td>{data.NewRequest.Vendor && data.NewRequest.CircuitType}</td>
                            </tr>
                            {data.Subscription.MobileServiceModel
                                && data.Subscription.MobileServiceModel.length > 0 ?
                                <tr>
                                    <td><Translation translationKey="mobile_service_type" /></td>
                                    <td>
                                        <Row>
                                            <Col xs={6} md={6} lg={6}>
                                                {data.Subscription.MobileServiceModel[0].EquipmentModel}
                                            </Col>
                                            <Col xs={6} md={6} lg={6}>
                                                {`${data.Subscription.MobileServiceModel[0].OrderCost} ${data.Subscription.PlanDetails.Currency.CurrencyName}`}
                                            </Col>
                                        </Row>
                                    </td>
                                </tr> : null
                            }

                            <tr>
                                <td><Translation translationKey="accessory" /></td>
                                <td>{data.Subscription.PhoneCaseAccessory ? YES_OR_NO.Yes : YES_OR_NO.No}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="plan_name" /></td>
                                <td>{data.NewRequest.PlanDetails && data.NewRequest.PlanDetails.PlanName}</td>
                            </tr>
                            {this.renderPlanComponents(data.NewRequest.PlanDetails.PlanComponents === null ? data.NewRequest.PlanDetails.PlanComponents : data.Subscription.PlanDetails.PlanComponents.slice(0, 1))}
                            
                            {data.Subscription.MobileServiceModel
                                && data.Subscription.MobileServiceModel.length > 0 &&
                                <tr>
                                    <td><Translation translationKey="total_order_cost" /></td>
                                    <td>{data.NewRequest.PlanDetails.TotalCost.toFixed(2)} {data.NewRequest.PlanDetails.Currency.CurrencyName}</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_business_justification" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data.BusinessJustification.PurposeOfUse}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_case" /></td>
                                <td>{data.BusinessJustification.DetailName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}